export default {"src":"/_next/static/media/android.4f015d82.gif","height":480,"width":480,"blurWidth":0,"blurHeight":0};